import Grid from "@material-ui/core/Grid";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "../../../components/Divider/Divider";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const ChildPosAdd = ({
  childPosAdd,
  handleChildPosAdd,
  childPosInfo,
  handleDropDownChangeAdd,
  error,
  readOnly,
}) => {
  const state = useSelector((state) => state.posDecentralized);
  const { t } = useTranslation();

  return (
    <>
      <Grid container spacing={3} style={{ padding: "1rem" }}>
        <Grid item sm={4}>
          <TextField
            variant="outlined"
            name="POSPOSISPOSCode"
            label={t(`Pos Code`)}
            size="small"
            value={state?.decentralizedEdit?.POSPOSISPOSCode || ""}
            disabled
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item sm={4}>
          <TextField
            variant="outlined"
            name="POSLegalName"
            label={t(`Parent Legal Name`)}
            size="small"
            value={state?.decentralizedEdit?.POSLegalName || ""}
            disabled
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={12} lg={12}>
        <Divider>{t(`Add`)}</Divider>
      </Grid>

      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSLegalName"
          label={t(`Legal Name`)}
          size="small"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          error={error.POSLegalName ? true : false}
          helperText={t(error.POSLegalName)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSStreet"
          label={t(`Street`)}
          size="small"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          error={error.POSStreet ? true : false}
          helperText={t(error.POSStreet)}
          disabled={readOnly}
        />
      </Grid>

      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSStreetNumber"
          label={t(`Street Number`)}
          type="number"
          inputProps={{ min: 0 }}
          size="small"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          error={error.POSStreetNumber ? true : false}
          helperText={t(error.POSStreetNumber)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSCity"
          label={t(`Pos City`)}
          size="small"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          error={error.POSCity ? true : false}
          helperText={t(error.POSCity)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSDistrict"
          label={t(`District`)}
          size="small"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          error={error.POSDistrict ? true : false}
          helperText={t(error.POSDistrict)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          name="POSState"
          options={childPosInfo?.state || []}
          getOptionLabel={(option) => option.stateDescription || ""}
          renderOption={(option) => <span>{option.stateDescription}</span>}
          onChange={(event, value) =>
            handleDropDownChangeAdd(event, value, "POS_StateSK", "stateSK")
          }
          disabled={readOnly}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              style={{ maxWidth: 225 }}
              InputLabelProps={{ shrink: true }}
              label={t(`State`)}
              variant="outlined"
              error={error.POS_StateSK ? true : false}
              helperText={t(error.POS_StateSK)}
            />
          )}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSZipCode"
          label={t(`Zip Code`)}
          type="number"
          inputProps={{ min: 0 }}
          size="small"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          error={error.POSZipCode ? true : false}
          helperText={t(error.POSZipCode)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSTaxID"
          label={t(`Tax ID`)}
          size="small"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          error={error.POSTaxID ? true : false}
          helperText={t(error.POSTaxID)}
          disabled={readOnly}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          name="taxcategoryDescription"
          options={childPosInfo?.taxcategory || []}
          getOptionLabel={(option) => option.taxcategoryDescription || ""}
          renderOption={(option) => (
            <span>{option.taxcategoryDescription}</span>
          )}
          disabled={readOnly}
          onChange={(event, value) =>
            handleDropDownChangeAdd(
              event,
              value,
              "POS_TaxCategorySK",
              "taxcategorySK"
            )
          }
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              style={{ maxWidth: 225 }}
              InputLabelProps={{ shrink: true }}
              label={t(`Tax Category`)}
              variant="outlined"
              error={error.POS_TaxCategorySK ? true : false}
              helperText={t(error.POS_TaxCategorySK)}
            />
          )}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSXCoordinate"
          label={t(`X Coordinate`)}
          size="small"
          type="number"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          disabled={readOnly}
          error={error.POSXCoordinate ? true : false}
          helperText={t(error.POSXCoordinate)}
        />
      </Grid>

      <Grid item sm={4}>
        <TextField
          variant="outlined"
          name="POSYCoordinate"
          label={t(`Y Coordinate`)}
          size="small"
          type="number"
          onChange={handleChildPosAdd}
          InputLabelProps={{ shrink: true }}
          disabled={readOnly}
          error={error.POSYCoordinate ? true : false}
          helperText={t(error.POSYCoordinate)}
        />
      </Grid>
      <Grid item sm={4}>
        <TextField
          select
          variant="outlined"
          name="POSStatus"
          label={t(`Status`)}
          size="small"
          disabled={readOnly}
          value={childPosAdd.POSStatus}
          onChange={handleChildPosAdd}
          style={{ minWidth: 220 }}
          InputLabelProps={{ shrink: true }}
        >
          <MenuItem value="A">Active</MenuItem>
          <MenuItem value="I">Inactive</MenuItem>
        </TextField>
      </Grid>
    </>
  );
};

export default ChildPosAdd;

ChildPosAdd.propTypes = {
  childPosAdd: PropTypes.object,
  handleChildPosAdd: PropTypes.func,
  childPosInfo: PropTypes.object,
  handleDropDownChangeAdd: PropTypes.func,
  error: PropTypes.object,
  readOnly: PropTypes.bool,
};
